
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/projected-closing",
      function () {
        return require("private-next-pages/[region]/projected-closing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/projected-closing"])
      });
    }
  